import React from "react";
import FooterMobile from "../components/modules/Footer/FooterMobile";

export default function AboutUsMobile() {
  return (
    <div className="min-[769px]:hidden relative w-full flex flex-col items-center justify-start bg-color-primary-A">
      <div
        dir="rtl"
        className="w-[300px]  flex flex-col items-center justify-center gap-y-[15px] px-[20px] py-[30px] rounded-[10px] bg-white mt-[100px]"
      >
        <div
          dir="rtl"
          className="w-full flex items-center justify-center gap-x-[8px] font-font_primary_A font-bold text-[12px] text-color-primary-D"
        >
          <span className="">جزو بهترین ها باش با </span>
          <span className="flex items-center justify-center bg-color-primary-B px-[10px] py-[5px] rounded-[5px]">
            اسکارپین
          </span>
        </div>
        <div className="w-full flex items-center justify-center font-font_primary_A font-normal text-color-primary-D text-[12px] text-justify">
          <p>
            کاربردی‌ترین اپلیکیشن‌ خودرو می باشد که به کمک آن می‌توانید تمامی
            اطلاعات مربوط به خودروی خود شامل تعمیرات، نگهداری، کیلومتر طی‌شده،
            مصرف سوخت و… را ذخیره کرده و مدیریتی هوشمندانه را تجربه کنید.
          </p>
        </div>
      </div>
      <div
        dir="rtl"
        className="relative w-[300px] h-[200px] flex flex-col items-center justify-center"
      >
        <div className="w-full flex items-center justify-center">
          <span className="font-font_primary_A font-bold text-[20px] text-color-primary-D">
            مالکان خودرو
          </span>
        </div>
        <div className="w-full flex items-center justify-center px-[40px]">
          <p className="max-w-[220px] font-font_primary_A font-bold text-[8px] text-color-primary-D text-justify">
            اپلیکیشن با سامانه اسکارپین ارتباط برقرار می‌کند. در این ارتباط
            سامانه پارامترهای «کارکرد و راه‌رفت» خودرو را دریافت و با یک
            الگوریتم محاسباتی هوشمند و مدل خودرو؛ تمام قطعات و اقلام مصرفی خودرو
            را قبل رسیدن به مراحل هشدار در اپلیکیشن آلارم و به کاربر نمایش
            می‌دهد.
          </p>
        </div>

        <div className="absolute  w-[1px] h-full top-0 left-[10px] bg-[#CCCCCC]"></div>
        <div className="absolute  w-[1px] h-[105%] top-0 right-[10px] bg-[#CCCCCC]"></div>
        <img
          src="../assets/images/other/line1_min.svg"
          className="absolute top-[105%] right-[10px] "
        />
        <img
          src="../assets/images/other/line2_min.svg"
          className="absolute top-full left-[10px]"
        />
        <div className="absolute top-[20%] left-[-10px] w-[40px] h-[40px] p-[8px] flex items-center justify-center bg-color-primary-B rounded-[15px] z-10">
          <img src="../assets/images/pieces/img_piece_radiator.svg" />
        </div>
        <div className="absolute top-[70%]  right-[-10px] w-[40px] h-[40px] p-[8px] flex items-center justify-center bg-color-primary-B rounded-[15px] z-10">
          <img src="../assets/images/pieces/img_piece_battery.svg" />
        </div>
        <div className="absolute top-[115%] left-[46%] w-[40px] h-[40px] p-[8px] flex items-center justify-center bg-color-primary-B rounded-[15px] z-10">
          <img src="../assets/images/pieces/img_piece_filter_petrol.svg" />
        </div>
      </div>

      <div
        dir="rtl"
        className="relative w-[300px]  flex flex-col items-center justify-center gap-y-[15px] px-[20px] py-[30px] rounded-[10px] bg-white mt-[100px]"
      >
        <div className="w-full flex items-center justify-center gap-x-[8px] font-font_primary_A font-bold text-[12px] text-color-primary-D">
          <span className="text-[16px]">مولتی اپلیکیشن</span>
        </div>
        <div className="w-full flex items-center justify-center font-font_primary_A font-normal text-color-primary-D text-[12px] text-justify">
          <p>
            نرم افزار اسکارپین یک برنامه قابل نصب بر روی تلفن همراه است که به
            واسطه آن می‌‌توانید یک مدیریت کلی بر روی خودرو خود و مسائل فنی آن
            داشته باشید. درواقع نرم ‏افزار اسکارپین یکی از کامل ترین و باکیفیت‏
            ترین نرم‌افزارهای تخصصی در زمینه خودرو و مدیریت و نگهداری آن در کشور
            می باشد که با هدف پاسخگویی به تمام نیازهای دارندگان خودرو طراحی و
            توسعه یافته است.
          </p>
        </div>
        <div className="absolute w-[1px] h-[100px] bottom-[-100px] left-1/2 bg-[#CCCCCC]"></div>
      </div>

      <div
        dir="rtl"
        className="relative w-[300px]  flex flex-col items-center justify-start gap-y-[15px]  rounded-[10px] bg-white mt-[100px]"
      >
        <div className="w-full h-[60px] flex items-center justify-center gap-x-[8px] font-font_primary_A font-bold text-[12px] rounded-t-[10px] bg-color-primary-D text-color-primary-A">
          <span className="text-[16px]">اسکارپین کارشو چجوری شروع کرد ؟</span>
        </div>
        <div className="w-full flex-1 flex items-center justify-center font-font_primary_A font-normal text-color-primary-D text-[12px] px-[20px] py-[10px] text-justify">
          <p>
            اسکارپین از سال 1400 با هدف پایش سلامت وسائل‌نقلیه توسط جوانان خلاق
            و توانمند در شرکت «پرشیا ایده و صنعت» طراحی و ساخته شده است.
            اسکارپین یک سامانه پویا و هوشمند بوده که براساس الگوی مصرف کاربران
            خودرو و با ساده سازی فرآیند تعویض قطعات و اقلام مصرفی، به حفظ و
            نگهداری خودرو کمک می‌نماید. اسکارپین این امکان را به کاربران خود
            می‌دهد تا در شبانه‌روز از طریق اپلیکیشن به سهولت بتوانند آخرین وضعیت
            سلامت خودرو خود را مشاهده و جهت رفع نیاز‌های خودرو خود به
            تعمیرگاه‌های معتبر و در دسترس مراجعه نمایند. به‌منظور جلب اعتماد
            کاربران، تمامی نیرو‌های خدماتی مستقر در تعمیرگاه‌های اسکارپین توسط
            این شرکت احراز و از فیلترهای صلاحیت ما عبور کرده‌اند.
          </p>
        </div>
        <div className="absolute w-[1px] h-[100px] bottom-[-100px] left-1/2 bg-[#CCCCCC]"></div>
      </div>

      <div
        dir="rtl"
        className="relative w-[300px]  flex flex-col items-center justify-start gap-y-[15px]  rounded-[10px] bg-white mt-[100px]"
      >
        <div className="w-full h-[60px] flex items-center justify-center gap-x-[8px] font-font_primary_A font-bold text-[12px] rounded-t-[10px] bg-color-primary-D text-color-primary-A">
          <span className="text-[16px]">
            مهم‌ترین دستاوردها در حوزه خودرو ؟
          </span>
        </div>
        <div className="w-full flex-1 flex items-center justify-center font-font_primary_A font-normal text-color-primary-D text-[12px] px-[20px] pb-[10px] text-justify">
          <ol className="list-[persian] space-y-[4px]">
            <li>
              رفع دغدغه‌های مربوط به زمان تعویض قطعات و اقلام مصرفی خودرو؛
            </li>
            <li>
              رفع دغدغه‌های مربوط به زمان تمدید معاینه‌فنی و بیمه شخص ثالث
              خودرو؛
            </li>
            <li>ایجاد تحول در زمینه پایش سلامت خودرو؛</li>
            <li>بهبود ارتباط بین کاربران با تعمیرگاه‌های معتبر و توانمند؛</li>
          </ol>
        </div>
        <div className="absolute w-[1px] h-[100px] bottom-[-100px] left-1/2 bg-[#CCCCCC]"></div>
      </div>
      <div
        dir="rtl"
        className="relative w-[300px]  flex flex-col items-center justify-start gap-y-[15px]  rounded-[10px] bg-white mt-[100px] mb-[100px]"
      >
        <div className="w-full h-[60px] flex items-center justify-center gap-x-[8px] font-font_primary_A font-bold text-[12px] rounded-t-[10px] bg-color-primary-D text-color-primary-A">
          <span className="text-[16px]">
            مزیت‌های استفاده از اپلیکیشن اسکارپین؟
          </span>
        </div>
        <div className="w-full flex-1 flex items-center justify-start font-font_primary_A font-normal text-color-primary-D text-[12px] px-[20px] pb-[10px] text-justify">
          <ol className="list-[persian] space-y-[4px]">
            <li>حذف کارت سرویس</li>
            <li>مشتری بیشتر</li>
            <li>خرید بدون واسطه</li>
            <li>خرید اعتباری</li>
          </ol>
        </div>
      </div>
      <FooterMobile />
    </div>
  );
}
